import { api } from '@tools/ui/api';
import { User } from '@tools/ui/types';

const routePrefix = '/auth';

export const login = async (token?: string, xeroOnboarding = false): Promise<User> => {
  return api.post(`${routePrefix}/google`, { token, xeroOnboarding });
};

export const bypassLogin = async (username: string, password: string): Promise<User> => {
  return api.post(`${routePrefix}/bypass`, { username, password });
};

export const logout = async (): Promise<void> => {
  return api.get(`${routePrefix}/logout`);
};

export const requestAccess = async (email: string, roleIds: string[]): Promise<void> => {
  return api.post(`${routePrefix}/request`, { email, roleIds });
};
